import React from 'react';
import { Grid, Paper, Typography, useTheme, useMediaQuery } from '@mui/material';
import { reportsMockData } from '../../data/reportsMockData';

export const SummaryCards: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const summaryCards = [
    {
      title: 'Total Cases',
      value: reportsMockData.summary.total,
      gradient: 'linear-gradient(135deg, #1e3a5f, #2d4e7d)',
    },
    {
      title: 'Active Cases',
      value: reportsMockData.summary.active,
      gradient: 'linear-gradient(135deg, #2d4e7d, #3d6ea7)',
    },
    {
      title: 'Pending Cases',
      value: reportsMockData.summary.pending,
      gradient: 'linear-gradient(135deg, #3d6ea7, #4d8ed1)',
    },
    {
      title: 'Closed Cases',
      value: reportsMockData.summary.closed,
      gradient: 'linear-gradient(135deg, #4d8ed1, #5daefd)',
    },
  ];

  return (
    <>
      {summaryCards.map((card, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Paper 
            sx={{ 
              p: { xs: 2, sm: 3 },
              background: card.gradient,
              color: 'white',
              display: 'flex',
              flexDirection: isMobile ? 'row' : 'column',
              alignItems: isMobile ? 'center' : 'flex-start',
              justifyContent: isMobile ? 'space-between' : 'flex-start',
              gap: isMobile ? 2 : 0,
            }}
          >
            <Typography variant="h3" sx={{ 
              mb: isMobile ? 0 : 1, 
              fontWeight: 'bold',
              fontSize: { xs: '2rem', sm: '2.5rem' },
            }}>
              {card.value}
            </Typography>
            <Typography sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
              {card.title}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </>
  );
};